import { success, error, warning } from '@/utils/message'

export default {
  mixins: [],
  computed: {
  },
  methods: {
    success (message, timeout, showClose) {
      success(message, timeout, showClose)
    },
    error (message, timeout, showClose) {
      error(message, timeout, showClose)
    },
    warning (message, timeout, showClose) {
      warning(message, timeout, showClose)
    },
  }
}
